<!-- change board access modal -->
<ng-container *ngIf="!showConfirmAddingNewFrameModal; else confirmAddingNewFrameModel">
  <app-modal-template
    [title]="'Change board access' | translate"
    [size]="
      (renderedAsMatBottomSheet | async)
        ? pencilModalSizeEnum.FULL_WIDTH
        : pencilModalSizeEnum.MEDIUM
    "
    [hasCloseButton]="true"
    [showActionsDivider]="true"
    (closeButtonClicked)="close()"
    [class]="'access-modal'"
    [class.bottom-sheet]="renderedAsMatBottomSheet | async"
  >
    <div class="description" content-description>
      <div class="description-header">
        <div class="privacy-options">
          <span class="title">{{ 'BOARD VISIBILITY' | translate }}</span>
          <app-pencil-drop-down-button
            [options]="privacyOptions"
            [selectedOption]="selectedPrivacyOption"
            (selectionChange)="handlePrivacyChange($event.id)"
          >
          </app-pencil-drop-down-button>
        </div>
        <ng-container
          *ngIf="currentPrivacyForFrame === FramePrivacy.PUBLIC; else privatePrivacyText"
        >
          <span>{{ 'All hosts and participants can access this board.' | translate }}</span>
        </ng-container>
      </div>
      <ng-container *ngIf="currentPrivacyForFrame === FramePrivacy.PRIVATE">
        <app-participants-selection-list
          [privateUsersForFrame]="selectedPrivateUsersForFrame"
          (participantSelectionChange)="handleParticipantsSelectionChange($event)"
        >
        </app-participants-selection-list>
      </ng-container>
    </div>
    <div class="actions-box" content-actions>
      <div class="access-modal-actions">
        <app-pencil-button
          theme="secondary"
          class="cancel-button"
          icon="close"
          [iconConfig]="{ type: IconTypes.matIcon }"
          [label]="'Cancel' | translate"
          (clickEvent)="close()"
        ></app-pencil-button>
        <app-pencil-button
          theme="primary"
          class="confirm-button"
          icon="check"
          [iconConfig]="{ type: IconTypes.matIcon }"
          [label]="'Confirm' | translate"
          (clickEvent)="handleConfirm()"
          [disabled]="shouldConfirmButtonDisabled()"
        ></app-pencil-button>
      </div>
    </div>
  </app-modal-template>
</ng-container>

<ng-template #privatePrivacyText>
  <span>{{ 'Only hosts and selected participants can access this board.' | translate }}</span>
</ng-template>

<ng-template #confirmAddingNewFrameModel>
  <!-- The following condition is to avoid showing the confirmation modal when showing the private board per participant modal -->
  <app-modal-template
    [title]="'Create new public board' | translate"
    [size]="pencilModalSizeEnum.SMALL"
    [hasCloseButton]="true"
    (closeButtonClicked)="close()"
  >
    <div class="description" content-description>
      {{ 'To make this board private, a new public board will be created as well' | translate }}
    </div>
    <div content-actions>
      <app-pencil-button
        theme="primary"
        icon="check"
        [iconConfig]="{ type: IconTypes.matIcon }"
        [label]="'OK' | translate"
        (clickEvent)="handleCreatePublicFrameButton()"
      >
      </app-pencil-button>
    </div>
  </app-modal-template>
</ng-template>
